import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Card, Input } from "@nextui-org/react";
import { Icon } from "@iconify/react";

const PromptNode = ({ data }) => {
  return (
    <Card className="p-4 w-[300px]">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <Icon icon="mdi:pencil" />
          </div>
          <span className="font-semibold">Prompt</span>
          {/* <span className="ml-auto text-sm text-green-500">38ms</span> */}
        </div>

        <div className="text-sm text-gray-500">
          Create a prompt template with dynamic variables.
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm ">Template</span>
            <Icon icon="mdi:eye" className="w-4 h-4 text-gray-400" />
          </div>
          <Input
            placeholder="Answer the user as if you were a"
            className="max-w-full"
          />
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm">Prompt Message</span>
          <Icon icon="mdi:eye" className="w-4 h-4 text-gray-400" />
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="promptMessage"
        className="w-3 h-3 bg-blue-500"
      />
    </Card>
  );
};

export default PromptNode;
